module.exports = __webpack_public_path__ + "static/media/servicios_telecomunicaciones.285478b0.jpg";